"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateField = void 0;

var tslib_1 = require("tslib");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_field_helper_message_1 = require("@hopin-team/ui-field-helper-message");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_menu_1 = require("@hopin-team/ui-menu");

var use_id_1 = require("@hopin-team/use-id");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("./context");

var date_picker_1 = require("./partials/date-picker");

var field_1 = require("./partials/field");

var month_picker_1 = require("./partials/month-picker");

var range_picker_1 = require("./partials/range-picker");

var year_picker_1 = require("./partials/year-picker");

var native_input_1 = require("./styled/native-input");

var root_1 = require("./styled/root");

var DateField = function DateField(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      date = _a.date,
      _dateOptions = _a.dateOptions,
      errorMessage = _a.errorMessage,
      hasErrors = _a.hasErrors,
      withRange = _a.withRange,
      helperText = _a.helperText,
      id = _a.id,
      isDisabled = _a.isDisabled,
      isReadOnly = _a.isReadOnly,
      isInline = _a.isInline,
      isRequired = _a.isRequired,
      label = _a.label,
      setDate = _a.setDate,
      setEndDate = _a.setEndDate,
      onDateChangeProp = _a.onDateChange,
      onEndDateChangeProp = _a.onEndDateChange,
      endDate = _a.endDate,
      requiredText = _a.requiredText,
      withTime = _a.withTime,
      minTime = _a.minTime,
      maxTime = _a.maxTime,
      stepTime = _a.stepTime,
      _b = _a.dayLabel,
      dayLabel = _b === void 0 ? 'day' : _b,
      _c = _a.monthLabel,
      monthLabel = _c === void 0 ? 'month' : _c,
      openCalendarLabel = _a.openCalendarLabel,
      _d = _a.sizeOption,
      sizeOption = _d === void 0 ? 'medium' : _d,
      _e = _a.yearLabel,
      yearLabel = _e === void 0 ? 'year' : _e,
      _f = _a.minuteLabel,
      minuteLabel = _f === void 0 ? 'minute' : _f,
      _g = _a.hourLabel,
      hourLabel = _g === void 0 ? 'hour' : _g;

  var _id = (0, use_id_1.useId)(id);

  var fieldId = "field-".concat(_id);
  var errorMsgId = "error-msg-".concat(_id);
  var helperMsgId = "helper-msg-".concat(_id);
  var onDateChange = onDateChangeProp || setDate;
  var onEndDateChange = onEndDateChangeProp || setEndDate;
  (0, react_1.useEffect)(function () {
    if (setDate || setEndDate) {
      console.warn('The setDate and setEndDate props will soon be deprecated on the DateField component. Please use onDateChange and onEndDateChange instead.');
    }
  }, [setDate, setEndDate]);

  var _h = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'DateField',
    className: className,
    __UIScope: __UIScope
  }),
      rootClasses = _h.rootClasses,
      makeClasses = _h.makeClasses;

  var a11yProps = {};

  if (hasErrors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  if (!hasErrors && helperText) {
    a11yProps['aria-describedby'] = helperMsgId;
  }

  var _j = tslib_1.__read((0, react_1.useState)(false), 2),
      isShowing = _j[0],
      setIsShowing = _j[1];

  var _k = tslib_1.__read((0, react_1.useState)(true), 2),
      isDatePicker = _k[0],
      setIsDatePicker = _k[1];

  var _l = tslib_1.__read((0, react_1.useState)(false), 2),
      isMonthPicker = _l[0],
      setIsMonthPicker = _l[1];

  var _m = tslib_1.__read((0, react_1.useState)(false), 2),
      isYearPicker = _m[0],
      setIsYearPicker = _m[1];

  var _o = tslib_1.__read((0, react_1.useState)(false), 2),
      isRangePicker = _o[0],
      setIsRangePicker = _o[1];

  var onClose = function onClose() {
    return setIsShowing(false);
  };

  var onDatePick = function onDatePick() {
    setIsDatePicker(true);
    setIsRangePicker(false);
    setIsMonthPicker(false);
    setIsYearPicker(false);
    setIsRangePicker(false);
  };

  var onMonthPick = function onMonthPick() {
    setIsDatePicker(false);
    setIsRangePicker(false);
    setIsMonthPicker(true);
    setIsYearPicker(false);
    setIsRangePicker(false);
  };

  var onYearPick = function onYearPick() {
    setIsDatePicker(false);
    setIsRangePicker(false);
    setIsMonthPicker(false);
    setIsYearPicker(true);
    setIsRangePicker(false);
  };

  var onRangePick = function onRangePick() {
    setIsRangePicker(true);
    setIsDatePicker(false);
    setIsMonthPicker(false);
    setIsYearPicker(false);
  };

  (0, react_1.useEffect)(function () {
    if (withRange) {
      setIsDatePicker(false);
      setIsRangePicker(true);
    }
  }, [withRange]);
  (0, react_1.useEffect)(function () {
    if (!minTime) {
      return;
    }

    minTime && onDateChange((0, date_fns_1.parse)(minTime, 'kk:mm', new Date()));
  }, [minTime, onDateChange]);

  var dateOptions = tslib_1.__assign(tslib_1.__assign({}, context_1.defaultContextValue.dateOptions), _dateOptions);

  var contextValue = {
    date: date,
    dateOptions: dateOptions,
    onDatePick: onDatePick,
    onMonthPick: onMonthPick,
    onYearPick: onYearPick,
    onRangePick: onRangePick,
    onDateChange: onDateChange,
    onEndDateChange: onEndDateChange,
    setIsShowing: setIsShowing,
    hourLabel: hourLabel,
    minuteLabel: minuteLabel,
    endDate: endDate,
    withRange: withRange,
    minTime: minTime,
    maxTime: maxTime,
    stepTime: stepTime
  };

  var _p = (0, ui_helper_hooks_1.useDeviceDetection)(),
      isTouchDevice = _p.isTouchDevice,
      isDesktop = _p.isDesktop; // For native input datefield


  var dateValue = (0, date_fns_1.isValid)(date) ? date : new Date();
  var dateString = (0, date_fns_1.format)(dateValue, "yyyy-MM-dd'T'HH:mm");
  var onChange = (0, react_1.useCallback)(function (e) {
    var newDate = new Date(e.target.value);
    onDateChange(newDate);
  }, [onDateChange]);
  return react_1.default.createElement(context_1.DateFieldContext.Provider, {
    value: contextValue
  }, react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID
  }, react_1.default.createElement(ui_field_label_1.FieldLabel, {
    className: makeClasses('Label'),
    fieldId: fieldId,
    isRequired: isRequired,
    label: label,
    requiredText: requiredText,
    isDisabled: isDisabled,
    mb: 0.5
  }), isTouchDevice && !withTime && !withRange && react_1.default.createElement(native_input_1.NativeInput, tslib_1.__assign({
    type: "date",
    id: fieldId,
    value: dateString,
    onChange: onChange,
    required: isRequired,
    disabled: isDisabled,
    readOnly: isReadOnly,
    hasErrors: hasErrors,
    isInline: isInline,
    sizeOption: sizeOption
  }, a11yProps)), isTouchDevice && withTime && !withRange && react_1.default.createElement(native_input_1.NativeInput, tslib_1.__assign({
    type: "datetime-local",
    id: fieldId,
    value: dateString,
    onChange: onChange,
    required: isRequired,
    disabled: isDisabled,
    readOnly: isReadOnly,
    hasErrors: hasErrors,
    isInline: isInline,
    sizeOption: sizeOption,
    min: minTime,
    max: maxTime,
    step: stepTime
  }, a11yProps)), (isDesktop || withRange) && react_1.default.createElement(ui_menu_1.Menu, {
    isInline: isInline,
    isShowing: isShowing,
    isDismissible: true,
    onClose: onClose
  }, react_1.default.createElement(field_1.Field, {
    id: fieldId,
    dayLabel: dayLabel,
    hasErrors: hasErrors,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isInline: isInline,
    label: label,
    monthLabel: monthLabel,
    openCalendarLabel: openCalendarLabel,
    sizeOption: sizeOption,
    yearLabel: yearLabel,
    withTime: withTime,
    minuteLabel: minuteLabel,
    hourLabel: hourLabel,
    withRange: withRange,
    ariaDescribedby: a11yProps['aria-describedby']
  }), react_1.default.createElement(ui_menu_1.MenuContent, {
    size: "medium"
  }, isDatePicker && react_1.default.createElement(date_picker_1.DatePicker, {
    withTime: withTime
  }), isMonthPicker && react_1.default.createElement(month_picker_1.MonthPicker, null), isYearPicker && react_1.default.createElement(year_picker_1.YearPicker, null), isRangePicker && react_1.default.createElement(range_picker_1.RangePicker, null))), hasErrors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId
  }), !hasErrors && helperText && react_1.default.createElement(ui_field_helper_message_1.FieldHelperMessage, {
    helperMessage: helperText,
    mt: 1,
    className: makeClasses('HelperMessage'),
    id: helperMsgId
  })));
};

var DateFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(DateField);
exports.DateField = DateFieldWithSpace;